module.exports = __webpack_public_path__ + "img/dt_icon.3ec0d994.jpg";